
import useColor from '~/composable/useColor';

export default {
  props: {
    bannerInfo: {
      type: Object,
      default: () => {}
    },
    brandLogo: {
      type: Object,
      default: () => {}
    }
  },
  setup() {
    const { getBackground, getTheme } = useColor()
    const scrollToProduct = () => {
      document.querySelector('#campaign-anchor').scrollIntoView({
        behavior: 'smooth'
      });
    }

    return {
      scrollToProduct,
      getTheme,
      getBackground
    }
  }
}
